export default {
  title: 'ארכיון סוכנים',
  notification: {
    errors: {
      find: {
        title: 'קיימת בעיה בהצגת הנתונים',
        message: 'לא ניתן למצוא סוכנים מהארכיון אנא נסה שנית',
      },
    },
  },
};
